import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { H6, B1 } from 'pfm-ui-components';
import { pxToRem } from '../../../styles/utils';

interface SuccessMessageProps {
  icon: JSX.Element; // icon to display
  successMessage: string; // success message it can be either congratulations, succes or successful.
  description: string; // detailed description the succes message
}
export default function SuccessMessage(props: SuccessMessageProps) {
  return (
    <SuccessMessageWrapper>
      {props.icon}
      <MessageWrapper>
        <StyledH6>{props.successMessage}</StyledH6>
      </MessageWrapper>
      <div>
        <SuccessUnderLine />
      </div>
      <DescriptionWrapper>
        <StyledB1>{props.description}</StyledB1>
      </DescriptionWrapper>
    </SuccessMessageWrapper>
  );
}

const SuccessMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledH6 = styled(H6)`
  color: ${(props) => props.theme.palette.burgundy1};
  ${up('md')} {
    font-size: ${pxToRem(20)};
  }
`;

const StyledB1 = styled(B1)`
  color: #4a4a4a;
`;

const MessageWrapper = styled.div`
  margin-top: ${pxToRem(8)};
`;

const DescriptionWrapper = styled.div`
  margin-top: ${pxToRem(8)};
  margin-bottom: ${pxToRem(24)};
  text-align: center;
  ${up('md')} {
    margin-top: ${pxToRem(16)};
    margin-bottom: ${pxToRem(32)};
  }
`;

const SuccessUnderLine = styled.hr`
  border-bottom: 2px solid ${(props) => props.theme.palette.burgundy1};
  width: ${pxToRem(24)};
`;
